import {useStore} from '@/core'
import {Logo as LogoBase, LogoWhite, LogoAllWhite} from './logos'
import {doc} from './doc'

export const Logo = doc(
  ({style}) => {
    const store = useStore()
    const [theme] = store.use(['theme'])
    if (style === 'allWhite')
      return <LogoAllWhite />
    if (theme === 'dark')
      return <LogoWhite />
    return <LogoBase />
  }
)
